




















import commons from "@/common/store/modules/commons";
import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import items from "@/general/store/modules/items";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ItemListPanel
  }
})
export default class ItemList extends Vue {
  @Prop({ type: Array, required: true }) items!: any;
  @Prop({ type: Boolean, default: false }) addToBrowserHistory!: boolean;

  status(item: any) {
    if (item?.is_quantity_control && item.quantity == 0) {
      //out of stock
      return "在庫なし";
    } else if (item.premium.is_new === true) {
      //New
      return "New";
    } else if (item.premium.is_featured === true) {
      //Recommended
      return "おすすめ";
    } else {
      //show nothing
      return false;
    }
  }

  getColor(item: any) {
    return item.is_quantity_control && item.quantity == 0
      ? "#333"
      : commons.colorCode;
  }
}
